import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import compact from 'lodash/compact';
import { defineMessages, injectIntl } from 'react-intl';
import CurrencyDataPod from '../../../components/CurrencyDataPod';

const messages = defineMessages({
  avgNetPrice: {
    id: 'hubs.overview.pod.average-net-price',
    defaultMessage: 'Average NET Price',
  },
  avgNetPriceCamino: {
    id: 'hubs.overview.pod.average-net-price',
    defaultMessage: 'Average Net Price',
  },
  anpTooltip: {
    id: 'hubs.overview.pod.average-net-price-tooltip',
    defaultMessage:
      'Average net price of attendance for full-time, first-time, degree/certificate-seeking undergraduate students who paid the in-state or in-district tuition rate and were awarded grant or scholarship aid.',
  },
  anpLinkText: {
    id: 'hubs.overview.pod.average-net-price.more-about-cost',
    defaultMessage: 'More about Cost & Aid',
  },
});

const AvgNetPrice = ({ isCamino, averageNetPrices, lastUpdated, intl }) => {
  const currencyValues = [];
  const incomeValues = [
    '$0 - $30k',
    '$30k - $48k',
    '$48k - $75k',
    '$75k - $110k',
    '> $110k',
  ];

  ['0-30.value', '30-48.value', '48-75.value', '75-110.value', '110+.value'].forEach(
    (key, index) => {
      const currencyValue = get(averageNetPrices, key, null);
      if (currencyValue) {
        currencyValues.push(currencyValue);
      } else {
        incomeValues[index] = null;
      }
    },
  );

  return (
    currencyValues.length > 0 && (
      <CurrencyDataPod
        header={intl.formatMessage(
          isCamino ? messages.avgNetPriceCamino : messages.avgNetPrice,
        )}
        footer={lastUpdated}
        tooltip={intl.formatMessage(messages.anpTooltip)}
        content={{
          currencyValues: currencyValues,
          incomeValues: compact(incomeValues),
          linkText: intl.formatMessage(messages.anpLinkText),
          linkUrl: 'Costs#cost-module',
        }}
      />
    )
  );
};

AvgNetPrice.propTypes = {
  averageNetPrices: PropTypes.object,
  lastUpdated: PropTypes.string,
  intl: PropTypes.object,
  isCamino: PropTypes.bool,
};

export default injectIntl(AvgNetPrice);
